import React from 'react';

/**
 * This context is used as a way to add offset in the child components.
 * Each child component can use these values as needed.
 */
const { Provider, Consumer } = React.createContext({
  offsetLeft: 0,
});

export { Provider as OffsetProvider, Consumer as OffsetConsumer };
